import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { catchError, expand, map, mergeMap, reduce } from 'rxjs/operators';
import { updateMsp } from '../../../msp/actions';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

const PERCENTAGE_ENCODED = '%25';

@Injectable()
export class CwmCompaniesEffects {
    loadMspCWMConfigCompanies$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspCwmCompanies),
            mergeMap(() =>
                this.getCompanies().pipe(
                    map((data) => actions.loadMspCwmCompaniesSuccess({ data })),
                    catchError((error) => {
                        this.store.dispatch(updateMsp({ data: { cwm: false } }));

                        return of(actions.loadMspCwmCompaniesFailure({ error }));
                    }),
                ),
            ),
        ),
    );

    getCompanies() {
        return this.mspAjax
            .get(
                `/api/octiga/v2/cwm/company/companies?conditions=(status/name like "Active${PERCENTAGE_ENCODED}" AND deletedFlag=false)&fields=id,name,status,site`,
            ) //&childConditions=types/name="Customer"
            .pipe(
                expand((res) => {
                    if (res.nextPageUrl) {
                        return this.mspAjax.get(
                            '/api/octiga/v2/cwm' + res.nextPageUrl.split('/v4_6_release/apis/3.0')[1],
                        );
                    }
                    return EMPTY;
                }),
                reduce((acc, res: any) => acc.concat(res.data), []),
            );
    }

    constructor(
        private actions$: Actions,
        private mspAjax: MspAjaxService,
        private store: Store<any>,
    ) {}
}
